import styled from 'styled-components'
import { Card } from '@blueprintjs/core'

export const AppMetierCard = styled(Card)`
  box-shadow: none;
  width: fit-content;
`
